function DownArrowSVG() {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8631 0L14 1.11781L7 8L0 1.11781L1.13694 0L7 5.76376L12.8631 0Z"
        fill="#F47521"
      />
    </svg>
  );
}

function UpArrowSVG() {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.13694 8.67847L9.7722e-08 7.56066L7 0.678466L14 7.56066L12.8631 8.67847L7 2.91471L1.13694 8.67847Z"
        fill="#F47521"
      />
    </svg>
  );
}

function LeftArrowSVG() {
  return (
    <svg
      width="13"
      height="21"
      viewBox="0 0 13 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0607 0L12.182 2.12132L4.24232 10.0607L12.182 18L10.0607 20.1213L0 10.0607L10.0607 0Z"
        fill="white"
      />
    </svg>
  );
}

function RightArrowSVG() {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.04481 10L-8.61508e-07 8.94573L3.91053 5L-1.71613e-07 1.05427L1.04482 5.20478e-07L6 5L1.04481 10Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export { 
  DownArrowSVG,
  UpArrowSVG,
  LeftArrowSVG,
  RightArrowSVG,
 };
